import { render, staticRenderFns } from "./financial-setting.vue?vue&type=template&id=6990a6ca&scoped=true"
import script from "./financial-setting.vue?vue&type=script&lang=js"
export * from "./financial-setting.vue?vue&type=script&lang=js"
import style0 from "./financial-setting.vue?vue&type=style&index=0&id=6990a6ca&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6990a6ca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/project/moneypay-web/moneypay-merchant-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6990a6ca')) {
      api.createRecord('6990a6ca', component.options)
    } else {
      api.reload('6990a6ca', component.options)
    }
    module.hot.accept("./financial-setting.vue?vue&type=template&id=6990a6ca&scoped=true", function () {
      api.rerender('6990a6ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/paycools/data/financial-setting.vue"
export default component.exports